<template>
  <ul class="test-item-list">
    <li class="test-item" v-for="(vocab,index) in vocabs" :key="index">
      <span class="order-num">{{index+1}}/
        <span class="total">{{vocabs.length}}</span>
      </span>
      <h4 class="test-title">
        <span class="test-word">{{vocab.word}}</span>
        <span class="pronunciation" v-if="vocab.us_announace || vocab.uk_announace">[{{vocab.announace_type === 'us' ? vocab.us_announace : vocab.uk_announace}}]</span>
        <span class="oral-type pointer-no-select" @click="playAnnounace(vocab, 'uk', index)">UK</span>
        <span class="oral-type pointer-no-select" @click="playAnnounace(vocab, 'us', index)">US</span>
      </h4>
      <p class="test-desc">{{vocab.definition}}</p>
      <ul class="test-demo">
        <li class="demo-item" v-for="(annotation, aindex) in (vocab.annotations || [])" :key="aindex">
          <p class="deom-example">{{annotation.text}}</p>
          <p class="demo-translate">{{annotation.translation}}</p>
        </li>
      </ul>
      <div class="test-action" v-if="actions">
        <button class="test-button text-center success-hover" :class="{'success': vocab.answer === 'yes'}" @click="cb(vocab, index, 'yes')">认识</button>
        <button class="test-button text-center error-hover" :class="{'error': vocab.answer === 'no'}" @click="cb(vocab, index, 'no')">不认识</button>
      </div>
    </li>
  </ul>
</template>
<script>
  import { playAudio } from "../service/utils";

  export default {
    props: {
      wdata: {
        type: Array,
        default: () => []
      },
      actions: {
        type: Boolean,
        default: true
      },
      cb: {
        type: Function,
        default: () => {}
      }
    },
    computed: {
      vocabs: (vm)=>{
        return vm.wdata;
      }
    },
    methods: {
      playAnnounace(data, type, index){
        let res = data;
        res.announace_type = type;
        this.vocabs.splice(index, 1, res);
        if (type === 'us') {
          playAudio(data.us_audio);
        } else {
          playAudio(data.uk_audio);
        }
      }
    }
  }
</script>